import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

// Silent visitor tracker — records a page hit (server derives the IP).
// Skips the private admin route so the owner's own checks aren't logged.
export const Tracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { path: pathname })
      .catch(() => {});
  }, [pathname]);
  return null;
};
